export const NEW_GOAL_PATH = '#/goals/new';

/** The new goal page's address (T-183): the AI source picked, a goal to start from, or a saved draft. */
export const newGoalHash = (options: { ai?: boolean; goal?: string; draft?: string } = {}) => {
  const query = new URLSearchParams();
  if (options.draft) query.set('draft', options.draft);
  if (options.goal) query.set('goal', options.goal);
  if (options.ai) query.set('ai', '1');
  const text = query.toString();
  return text ? `${NEW_GOAL_PATH}?${text}` : NEW_GOAL_PATH;
};
